<template>
  <div class="serverList">
    <div class="chooseOne " >
      <div @click="home('20')" :class="this.isClicked ? 'p1' : 'pOne'">
        <p>已处理</p>
        <div></div>
      </div>
      <div @click="home('10')" :class="this.isClicked2 ? 'p2' : 'pTow'">
        <p>未处理</p>
        <div></div>
      </div>
    </div>
    <ul>
      <li v-for="item in process" :key="item.index">
        <h3 style="margin-left: 0.4rem;">{{item.title}}</h3>
        <p class="content">{{item.problem}}</p>
        <img v-if="item.problemImageUrl" :src="item.problemImageUrl">
        <p class="time">上报日期：{{item.sponsorDate}}</p>
      </li>
    </ul>
    <div :class="loadMoreHide ? 'load-more-hide' : 'load-more-normal'" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
      <span v-show="loadingShow">加载中...</span>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        process:[],
        isClicked:true,
        isClicked2:false,
        busy: false,
        loadMoreHide:false,
        loadingShow:false,
        page:0,//
        pageSize:10,
        isLastPage:0,
        dispose:'20'
      }
    },
    mounted (){

    },
    methods:{
      home(val){
        this.process = []
        this.page = 1
        this.dispose = val
        if(val === '20'){
          this.isClicked = true
          this.isClicked2 = false
        }else{
          this.isClicked = false
          this.isClicked2 = true
        }
        this.request(true)
      },
      request(flag){
        const _this = this
        _this.postRequest('house/queryReformBillVOList',{
          page:_this.page,
          size:_this.pageSize,
          billState:this.dispose
        },function (data) {
          console.log(data)
          if(flag){
            if(data){
              _this.process=_this.process.concat(data.datas)
              if(_this.page < data.pages){
                _this.busy = false
              }else{
                _this.busy = true
                _this.loadingShow = false
              }
            }else {
              _this.loadingShow = false
            }
          }
        })
      },
      loadMore () {
        // 多次加载数据
        this.busy = true
        this.loadingShow = true
        this.page++
        this.request(true)
      },
    }
  }
</script>
<style scoped>
  .serverList{
    width:100%;
    height:100%;
  }
  .serverList .chooseOne{
    height:100px;
    line-height: 100px;
    text-align:center;
    background-color: #fff;
    display: flex;
    justify-content:space-around;
    font-size: 34px;
  }
  .serverList .chooseOne .p1{
    margin-left: 120px;
    color: #F7B632;
  }
  .serverList .chooseOne .p1 div{
    width: 35px;
    height: 6px;
    background:rgba(247,182,50,1);
    border-radius:3px;
    margin-left: 16px;
    margin-top: -6px;
  }
  .serverList .chooseOne .pOne{
    margin-left: 120px;
    color: #333;
  }

  .serverList .chooseOne .p2{
    margin-right: 120px;
    color: #F7B632;
  }
  .serverList .chooseOne .p2 div{
    width: 35px;
    height: 6px;
    background:rgba(247,182,50,1);
    border-radius:3px;
    margin-left: 16px;
    margin-top: -6px;
  }
  .serverList .chooseOne .pTow{
    margin-right: 120px;
    color: #333333;
  }
  .serverList ul{
    background-color: #f2f2f2;
    padding: .2rem 0;
    box-sizing: border-box;
  }
  .serverList ul li{
    box-sizing: border-box;
    background-color: #fff;
    margin: .3rem 26px;
    border-radius:10px;
    padding: 34px 23px;
    text-align: left;
  }
  .serverList ul li img{
    width: 1.5rem;
    height: 1.5rem;
    margin-left: .4rem;
  }
  /*报修内容*/
  .serverList ul li .content{
    font-size: 28px;
    width: 550px;
    color: #333;
    text-align: left;
    margin-left: 30px;
    line-height: 48px;
  }
  /*上报时间*/
  .serverList ul li .time{
    text-align: left;
    font-size: 24px;
    color: #999;
    margin:10px 0 0 30px;
    padding-bottom: 20px;
  }
  .load-more-normal {
    text-align: center;
    line-height: 60px;
  }

  .load-more-hide {
    height: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/pub-component/mobile-home/home-inspection-application.vue